/* ROUTERS  */
export const ROUTES = {
  MAIN: '/',
  LOGOUT: '/logout',
  LOGIN: '/login',
  VERIFY: '/verify',
  AUTHENTICATION: '/authentication',
  PROFILE: '/profile',
  HISTORY: '/history',
  UPLOADKEYS: '/upload-keys',
};

/*  Modules */
export const MODULES = {
  DASHBOARD: 'Dashboard',
  HISTORY: 'History',
};

/* Authentication */
export const TOKEN = 'TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER = 'USER';
export const IS_TWO_FA_ENABLED = 'IS_TWO_FA_ENABLED';
export const TWO_FA_KEY = 'TWO_FA_KEY';
export const TOPIC_ID = 'TOPIC_ID';
export const PROJECT_DATA = 'PROJECT_DATA';
export const SOURCE_TYPE = 'SOURCE_TYPE';
export const TOPIC_DATA = 'TOPIC_DATA';

export const ROLES = {
  SUPER_ADMIN: 'Super admin',
  ADMIN: 'Admin',
};

export const ROLE_KEYS = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
};

/* Date and time */
export const defaultDateFormat = 'MM/DD/YYYY';
export const defaultLogTimeFormat = 'hh:mm:ss a DD/MM/YYYY';

export const REGEX = {
  NAME: /^[a-z ,.'-]+$/i,
  ZIPCODE: /^[0-9]{5,6}$/,
  CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  WEB_URL: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  PASSWORD: /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
  PHONE: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
  EMAIL: /^(([^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+(\.[^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  AMOUNT: /^\d+$|^\d+\.\d*$/,
  OPTIONALNEGATIVEAMOUNT: /^[-]?\d+$|^[-]?\d+\.\d*$/,
  NUMBER: /^\d+$/,
  COUNTRY_CODE_PHONE: /^[0-9]{7,12}$/,
  CAPITAL_LETTER_AND_NUMBER_WITH_NO_BLANK_SPACE: /^[A-Z_\d]+$/,
  ENV_KEY: /^[A-Z0-9]+(_[A-Z0-9]+)*$/,
};

export const LIMIT = 10;
export const SCROLL_PERCENT = 0.85;

export const ORDER = [
  { name: 'Ascending', value: 'ASC' },
  { name: 'Descending', value: 'DESC' },
];

export const ERROR_PAGE_TITLE = 'Oops! An error occurred!';
export const ERROR_PAGE_SUBTITLE =
  'Something is broken. Please let us know what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.';

export const GUTTER_VARIATIONS = { xs: 16, sm: 16, md: 24, lg: 32 };

export const BREAKPOINTS = {
  mobile: 550,
  tablet: 767,
  desktop: 1000,
  hd: 1200,
};

export const OPERATIONS = {
  VIEW_PRIVATE_KEY: 'VIEW_PRIVATE_KEY',
  DELETE_KEY: 'DELETE_KEY',
  DELETE_ENV: 'DELETE_ENV',
  VERIFY_ENV: 'VERIFY_ENV',
  EXPORT_ENV: 'EXPORT_ENV',
};

export const LOGS_ACTION = {
  ADDED: 'Add',
  DELETED: 'Delete',
  UPDATED: 'Update',
  DUPLICATED: 'Duplicate',
  EXPORTED: 'Exported',
  VERIFIED: 'Verify',
  VIEWED: 'View',
};

export const ENV_KEY_TYPE = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
};
